import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return (
    <div className="min-h-screen flex flex-col bg-ink text-shell">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
